(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["breadcrumb"] && !Shopify.designMode) return;
  try {
    (() => {
  const STORAGE_KEY = 'dstrezzed-plp-breadcrumb';
  const CATEGORY_PARAM = 'filter.p.m.askphill.filter_category';

  const readStoredContext = () => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      const data = JSON.parse(raw);
      if (!data || typeof data !== 'object') return null;
      if (!data.handle || !data.title || !data.url) return null;

      return data;
    } catch (error) {
      return null;
    }
  };

  const parseProductCollections = (breadcrumb) => {
    try {
      const parsed = JSON.parse(breadcrumb.dataset.productCollections || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const getReferrerContext = () => {
    try {
      if (!document.referrer) return null;

      const referrer = new URL(document.referrer);
      if (referrer.origin !== window.location.origin) return null;

      const match = referrer.pathname.match(/\/collections\/([^/]+)/);
      if (!match) return null;

      const handle = decodeURIComponent(match[1]);
      const categoryValues = referrer.searchParams
        .getAll(CATEGORY_PARAM)
        .flatMap((value) =>
          value
            .split(',')
            .map((part) => part.trim())
            .filter(Boolean)
        );
      const category = categoryValues.join(', ');

      return { handle, category };
    } catch (error) {
      return null;
    }
  };

  const resolveContext = (productCollections) => {
    const stored = readStoredContext();
    const referrer = getReferrerContext();
    const byHandle = new Map(productCollections.map((item) => [item.handle, item]));

    if (referrer) {
      const matched = byHandle.get(referrer.handle);
      if (!matched) return null;

      if (stored && stored.handle === referrer.handle) {
        return {
          title: stored.category || stored.title || matched.title,
          url: stored.category ? stored.categoryUrl || stored.url : stored.url || matched.url,
        };
      }

      if (referrer.category) {
        const categoryUrl = new URL(matched.url, window.location.origin);
        categoryUrl.searchParams.set(CATEGORY_PARAM, referrer.category);

        return {
          title: referrer.category,
          url: `${categoryUrl.pathname}${categoryUrl.search}`,
        };
      }

      return {
        title: matched.title,
        url: matched.url,
      };
    }

    if (!stored) return null;

    const matched = byHandle.get(stored.handle);
    if (!matched) return null;

    return {
      title: stored.category || stored.title || matched.title,
      url: stored.category ? stored.categoryUrl || stored.url : stored.url || matched.url,
    };
  };

  const applyContext = (breadcrumb, context) => {
    const collectionEl = breadcrumb.querySelector('[data-breadcrumb-collection]');
    const linkEl = breadcrumb.querySelector('[data-breadcrumb-collection-link]');
    if (!(collectionEl instanceof HTMLElement) || !(linkEl instanceof HTMLElement)) return;

    linkEl.textContent = context.title;

    if (context.url) {
      linkEl.setAttribute('href', context.url);
    } else {
      linkEl.removeAttribute('href');
    }

    collectionEl.hidden = false;
  };

  const updateBreadcrumb = (breadcrumb) => {
    if (!(breadcrumb instanceof HTMLElement)) return;
    if (breadcrumb.dataset.collectionLocked === 'true') return;

    const productCollections = parseProductCollections(breadcrumb);
    if (productCollections.length === 0) return;

    const context = resolveContext(productCollections);
    if (!context || !context.title) return;

    applyContext(breadcrumb, context);
  };

  const updateAll = () => {
    const breadcrumbs = document.querySelectorAll('.product-breadcrumb');

    for (const breadcrumb of breadcrumbs) {
      updateBreadcrumb(breadcrumb);
    }
  };

  updateAll();
  document.addEventListener('shopify:section:load', updateAll);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["page-breadcrumb"] && !Shopify.designMode) return;
  try {
    (() => {
  const CATEGORY_PARAM = 'filter.p.m.askphill.filter_category';
  const DEFAULT_CATEGORY_LABEL = 'All';
  const STORAGE_KEY = 'dstrezzed-plp-breadcrumb';

  const getCategoryValues = (params, paramName) =>
    params.getAll(paramName).flatMap((value) =>
      value
        .split(',')
        .map((part) => part.trim())
        .filter(Boolean)
    );

  const getCategoryLabel = (params, paramName) =>
    getCategoryValues(params, paramName).join(', ') || DEFAULT_CATEGORY_LABEL;

  const persistPlpContext = (breadcrumb) => {
    if (!(breadcrumb instanceof HTMLElement)) return;

    const handle = breadcrumb.dataset.plpHandle;
    const title = breadcrumb.dataset.plpTitle;
    const url = breadcrumb.dataset.plpUrl;
    if (!handle || !title || !url) return;

    const paramName = breadcrumb.dataset.categoryParam || CATEGORY_PARAM;
    const params = new URLSearchParams(window.location.search);
    const categoryValues = getCategoryValues(params, paramName);
    const category = categoryValues.join(', ');

    let categoryUrl = url;
    if (category) {
      const nextUrl = new URL(url, window.location.origin);
      nextUrl.searchParams.delete(paramName);
      for (const value of categoryValues) {
        nextUrl.searchParams.append(paramName, value);
      }
      categoryUrl = `${nextUrl.pathname}${nextUrl.search}`;
    }

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          handle,
          title,
          url,
          category,
          categoryUrl,
        })
      );
    } catch (error) {
      // sessionStorage may be unavailable
    }
  };

  const updateCategory = (breadcrumb) => {
    persistPlpContext(breadcrumb);

    const labelEl = breadcrumb.querySelector('[data-breadcrumb-category-label]');
    if (!(labelEl instanceof HTMLElement)) return;

    const paramName = breadcrumb.dataset.categoryParam || CATEGORY_PARAM;
    // URL is updated before filter:update; FormData in the event can be stale (e.g. Reset filters).
    const params = new URLSearchParams(window.location.search);
    labelEl.textContent = getCategoryLabel(params, paramName);
  };

  const updateAll = () => {
    const breadcrumbs = document.querySelectorAll('.page-breadcrumb[data-collection-mode], .page-breadcrumb[data-plp-handle]');

    for (const breadcrumb of breadcrumbs) {
      if (!(breadcrumb instanceof HTMLElement)) continue;

      if (breadcrumb.hasAttribute('data-collection-mode')) {
        updateCategory(breadcrumb);
      } else {
        persistPlpContext(breadcrumb);
      }
    }
  };

  updateAll();

  document.addEventListener('filter:update', updateAll);

  window.addEventListener('popstate', updateAll);

  // Apply filters only closes the drawer; re-sync in case a prior update used stale params.
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (!target.closest('.facets__see-results')) return;
    updateAll();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
